export default {
  noAlarms: 'Nie znaleziono aktywnych alarmów',
  activeAlarms: 'Aktywne alarmy',
  acknowledgeAll: 'Potwierdź wszystkie',
  enableNotificationsForNewAlarms: 'Powiadamiaj o alarmach',
  enableNotificationsForNewAlarmsTooltip: 'Wyświetlaj powiadomienie w przeglądarce, gdy pojawi się nowy alarm.',
  newAlarmNotificationTitle: 'Nowy alarm',
  notificationsPermissionDeniedTooltip: 'Nie zezwolono na powiadomienia w przeglądarce.',
  notificationsPermissionUnsupportedTooltip: 'Twoja przeglądarka nie obsługuje powiadomień.',
};
